export default __webpack_public_path__ + "static/media/ic_done_circle.cfb7547b.svg";